/**
 * Compat con datos legados que llegaban como Timestamp de Firestore.
 * La API (MariaDB) ya entrega Date/string; esto solo cubre payloads viejos
 * cacheados en el navegador, y evita depender del SDK de Firebase.
 */
export interface TimestampLike {
  toDate(): Date;
}

export const isTimestampLike = (value: unknown): value is TimestampLike =>
  typeof (value as TimestampLike | null | undefined)?.toDate === 'function';
